import CustomUspDelivery from '@public/icons/usp_5_new.svg';
import React, { SVGProps } from 'react';

type CustomUspDeliveryWrapperProps = SVGProps<SVGSVGElement>;
const CustomUspDeliveryWrapper: React.FC<CustomUspDeliveryWrapperProps> = (props) => {
  return <CustomUspDelivery {...props} />;
};

export default CustomUspDeliveryWrapper;
